import { createContext } from "react";

export interface ShowErrorToastType {
  open: boolean;
  errorMessage: string;
  errorTitle: string;
}

interface InitialStateType {
  showErrorToastState: ShowErrorToastType;
  showErrorToastSetState: any;
}

const ShowErrorToastContext = createContext<InitialStateType[]>([]);

export default ShowErrorToastContext;
